<div class="menu-item-form">
  <div class="group">
    <input
      type="text"
      [(ngModel)]="item.itemName"
      placeholder="Item Name"
      required
      />
    @if (!item.variants?.length) {
      <input
        type="number"
        [(ngModel)]="item.basePrice"
        placeholder="Price"
        class="price-no-variants"
        />
    }
  </div>

  <textarea
    [(ngModel)]="item.itemDescription"
    placeholder="Description"
  ></textarea>

  <!-- Variants Section -->
  <div class="variants-section">
    <h4>Variants</h4>
    @if (item.variants?.length) {
      <ul>
        @for (variant of item.variants; track variant; let i = $index) {
          <li>
            <input
              type="text"
              [(ngModel)]="variant.name"
              placeholder="Variant Name"
              />
            <input type="number" [(ngModel)]="variant.price" placeholder="Price" />
            <div>
              <input
                type="checkbox"
                [checked]="variant.default"
                (change)="setDefaultVariant(i)"
                />
              <label>Default</label>
            </div>
            <fa-icon
              [icon]="faTrash"
              class="delete"
              (click)="removeVariant(i)"
            ></fa-icon>
          </li>
        }
      </ul>
    }
    <button (click)="addVariant()">+ Add Variant</button>
  </div>

  <!-- Save/Cancel Buttons -->
  <div class="form-actions">
    <button (click)="submit()">Save Item</button>
    <button (click)="cancelEdit()">Cancel</button>
  </div>
</div>
